export class PopUp {
  constructor() {
    this.popup = $('.m-popup');
    this.overlay = $('.m-overlay');
    this.close = $('.c-close-modal');

    this.submit = $('.button--submit-newsletter');
    this.email = $('.email--input-newsletter');
    this.form = this.email.parent();

    this.closeNews = $('.close-popup');
    this.popupNews = $('.popup-overplay');
    this.checkbox = $('.checkbox--popup');
    this.accettazione = $('.privacy-acceptance');
    this.message = this.popup.find('.message');

    this.actions();
  }

  actions() {
    this.overlay.on('click', () => {
      this.popup.hide();
    });

    this.close.on('click', () => {
        this.popup.hide();
    });

    this.form.on('submit', (event) => { // blocco l'invio tramite tasto Enter della form
      event.preventDefault();
    });

    this.submit.on('click', () => {
      this.message.hide();
      this.message.removeClass('messaggio-successo');
      this.message.removeClass('messaggio-errore');

      this.accettazione.removeClass('input__check-error');
      if (this.checkbox.is(':checked')) {
        let _self = this;
        $.ajax({
          type: "POST",
          data: "mail=" + this.email.val(),
          url: _url + 'ajax/ajax.newsletter_iscrizione.php',
          success: function(result) {
            window.dataLayer.push({
              'event': 'newsletterSubmit'
            });

            _self.message.addClass('messaggio-successo');
            _self.message.text(_translations.newsletter_ok);
            _self.message.show();

            setTimeout(function() {
              $('.popup-overplay').fadeOut();
            }, 1000);

            document.cookie = "newsletter=1; expires=; path=/";
          }
        });
      } else {
        this.accettazione.addClass( 'input__check-error' );

        this.message.addClass('messaggio-errore');
        this.message.text(_translations.newsletter_ko);
        this.message.show();
      }
    });

    this.closeNews.on('click', () => {
      this.popupNews.fadeOut();
      document.cookie = "newsletter=1; path=/";
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/pop-up.js